import { observer } from "mobx-react-lite";
import React from "react";

import { NaocProductionTarget } from "./NaocProductionTarget";

export const ProductionTargetBaseView = observer(() => {
  return <NaocProductionTarget />;
});

